<template>
  <div class="base-checkbox-group">
    <slot />
  </div>
</template>

<script>
export default {
  name: "BaseCheckboxGroup",
  provide() {
    return { checkboxGroup: this };
  },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
